const en = {
  // Navbar
  "nav.about": "About Us",
  "nav.services": "Services",
  "nav.cases": "Portfolio",
  "nav.roadmap": "Roadmap",
  "nav.cta": "👉 Wake the Monster",
  "nav.langToggle": "中文",

  // Hero
  "hero.tagline": "Wild Ideas · Raw Power · Cinematic Quality · 7-Day Delivery",
  "hero.scrollLabel": "Scroll Down",

  // About
  "about.sectionTag": "ABOUT_US.exe",
  "about.sloganMain": "7-DAY DELIVERY",
  "about.sloganPre": "Pixel Monster delivers every frame of",
  "about.sloganHighlight": "cinematic",
  "about.sloganPost": "imagination.",
  "about.titleLine1": "A pack of AI-tamed",
  "about.titleLine2": "Visual Wild Beasts",
  "about.card1Label": "// 01_IDENTITY",
  "about.card1Text1": "Welcome to the lair of",
  "about.card1Brand": "Pixel Monster",
  "about.card1Text2": ". We\'re not those traditional film companies that spend half a day in meetings, two days on lighting setup, and burn half your budget on crew lunches. We\'re a pure-breed",
  "about.card1Highlight": "\"AI Video Dream Factory\"",
  "about.card1Text3": ".",
  "about.card2Label": "// 02_POWER",
  "about.card2Text1": "Here, there\'s no sluggish post-production — only",
  "about.card2Highlight1": "explosive compute power",
  "about.card2Text2": ". Our staple is",
  "about.card2Highlight2": "the industry\'s most cutting-edge AI models",
  "about.card2Text3": "(and we know exactly how to write the spells that make AI obey).",
  "about.card3Label": "// 03_PROMISE",
  "about.card3Text1": "Our promise is simple and brutal:",
  "about.card3Highlight1": "high quality, high efficiency, no BS",
  "about.card3Text2": ". Once the script is locked, the countdown starts —",
  "about.card3Highlight2": "7 days",
  "about.card3Text3": " to your blockbuster.",
  "about.card3Cta": "View Our Portfolio",
  "about.workspaceLabel": "// WORKSPACE",
  "about.workspaceDesc": "AI-Powered Creative Space",
  "about.techLabel": "// TECHNOLOGY",
  "about.techDesc": "Top AI Models × Visual Magic",

  // Services
  "services.sectionTag": "CORE_SERVICES.sys",
  "services.title": "Monster\'s 4 Ultimate Skills",
  "services.subtitle": "// Redefining video production with AI compute",
  "services.featuresLabel": "// MONSTER_PREY_",
  "services.cta": "Learn More",
  "services.s1.number": "01_",
  "services.s1.title": "📺 Product TVC",
  "services.s1.subtitle": "Make your product go viral on screen",
  "services.s1.description": "Can\'t capture the perfect arc of a water droplet in traditional filming? Can\'t build a futuristic cyberpunk kitchen? Hand it to us.",
  "services.s1.f1": "Whether it\'s a heartwarming smart home story, a premium beauty device film, or an addictive FMCG creative ad",
  "services.s1.f2": "Precise control over art styles from \"cozy family warmth\" to \"minimalist luxury\"",
  "services.s1.f3": "No need to wait for the perfect weather — in our servers, it\'s golden hour every day",
  "services.s2.number": "02_",
  "services.s2.title": "🎵 Music MV & Virtual Idols",
  "services.s2.subtitle": "Starmaking? We mass-produce it",
  "services.s2.description": "Want to create a super catchy anthem for your brand? Or launch a boy/girl group that never gets cancelled?",
  "services.s2.f1": "Full service from AI music generation (lyrics + composition, multilingual vocals) to MV visual production",
  "services.s2.f2": "Expert at crafting unique visuals, voices, and personas for virtual idol groups and digital idols",
  "services.s2.f3": "Creating tireless superstar groups that never need a break",
  "services.s3.number": "03_",
  "services.s3.title": "🤖 Digital Human IP Videos",
  "services.s3.subtitle": "The ultimate spokesperson that never tires",
  "services.s3.description": "Real KOLs get tired and raise their prices — our digital humans don\'t. We provide complete AI digital human solutions to make them your exclusive cyber celebrity.",
  "services.s3.f1": "Incubate brand-exclusive digital human IPs — from short video matrix content and commercial sales videos to brand story releases",
  "services.s3.f2": "Build your exclusive super spokesperson with a perfect persona, ready from frame zero",
  "services.s3.f3": "24/7 content production that never stops",
  "services.s4.number": "04_",
  "services.s4.title": "🌌 Exhibition Screens & Offline Visuals",
  "services.s4.subtitle": "The ultimate retina-shattering weapon",
  "services.s4.description": "Want to grab potential clients at industry expos, AI art festivals, or tech conferences with your product?",
  "services.s4.f1": "Massive-scale, ultra-high-resolution visual impact",
  "services.s4.f2": "From cutting-edge naked-eye 3D visuals to grand future city sandboxes",
  "services.s4.f3": "Every pixel the monster renders helps you capture offline traffic",

  // Cases
  "cases.sectionTag": "CASE_LIBRARY.db",
  "cases.title": "Pixel Monster Portfolio",
  "cases.filterAll": "All",
  "cases.filterTvc": "TVC",
  "cases.filterMv": "MV",
  "cases.filterDigital": "Digital Human",
  "cases.filterExhibition": "Exhibition",
  "cases.filterDrama": "AI Drama",
  "cases.noResults": "// NO_RESULTS_FOUND",
  "cases.noResultsDesc": "No cases in this category",
  "cases.featured": "FEATURED",
  "cases.case1.title": "Premium Mattress Launch Film",
  "cases.case1.desc": "Minimalist Luxury × Future Tech Aesthetics",
  "cases.case1.tag1": "Product Ad",
  "cases.case1.tag2": "Premium Beauty",
  "cases.case1.tag3": "60s",
  "cases.case2.title": "Virtual 2D Idol Debut MV",
  "cases.case2.desc": "Cyberpunk Style × Dynamic EDM",
  "cases.case2.tag1": "Music Video",
  "cases.case2.tag2": "Virtual Idol",
  "cases.case2.tag3": "90s",
  "cases.case3.title": "AWE Electronics Expo Opening Film",
  "cases.case3.desc": "Naked-Eye 3D × Stunning Visuals",
  "cases.case3.tag1": "Exhibition Screen",
  "cases.case3.tag2": "Tech Vibes",
  "cases.case3.tag3": "120s",
  "cases.case4.title": "Smart Appliance Heartwarming Film",
  "cases.case4.desc": "Cozy Family Warmth × Life Aesthetics",
  "cases.case4.tag1": "Brand Story",
  "cases.case4.tag2": "Appliances",
  "cases.case4.tag3": "75s",
  "cases.case5.title": "Digital Human Brand Endorsement",
  "cases.case5.desc": "Exclusive IP × Full-Scenario Application",
  "cases.case5.tag1": "Digital Human IP",
  "cases.case5.tag2": "Brand Endorsement",
  "cases.case5.tag3": "Series Videos",
  "cases.case6.title": "AI Short Drama / Animation",
  "cases.case6.desc": "Visual Explosion × MAX Youth Energy",
  "cases.case6.tag1": "AI Short Drama",
  "cases.case6.tag2": "Creative Animation",
  "cases.case6.tag3": "60s",
  "cases.case7.title": "Anime Series / AI Drama",
  "cases.case7.desc": "2D Universe × AI Story Engine",
  "cases.case7.tag1": "Anime Series",
  "cases.case7.tag2": "AI Short Drama",
  "cases.case7.tag3": "Series Content",

  // Roadmap
  "roadmap.sectionTag": "EVOLUTION_MAP.json",
  "roadmap.title": "Monster Evolution Theory",
  "roadmap.subtitle": "// The evolution from efficiency beast to AI visual infrastructure",
  "roadmap.p1.number": "Phase 1",
  "roadmap.p1.title": "⚡️ Efficiency Beast",
  "roadmap.p1.target": "Become the industry\'s \"delivery ceiling.\" Perfect the 7-day delivery standard for 60-90 second videos, crushing traditional outsourcing with extreme value and quality.",
  "roadmap.p1.a1": "Build a massive AI video portfolio covering short videos, TVC, and MV",
  "roadmap.p1.a2": "Establish the brand name: \"Pixel Monster — save money, get stunned\"",
  "roadmap.p1.a3": "Optimize AI workflows for standardized rapid delivery",
  "roadmap.p2.number": "Phase 2",
  "roadmap.p2.title": "🧠 IP Incubation Lair",
  "roadmap.p2.target": "Upgrade from \"contract work for others\" to \"owning our own digital assets.\"",
  "roadmap.p2.a1": "Deep integration of generative AI with digital human technology",
  "roadmap.p2.a2": "Deliver complete \"virtual IP commercial operation strategies\" to brands",
  "roadmap.p2.a3": "Build several million-follower virtual short video creator accounts",
  "roadmap.p3.number": "Phase 3",
  "roadmap.p3.title": "🪐 Fully Automated Dream Engine",
  "roadmap.p3.target": "Launch the \"Pixel Monster\" proprietary workbench and project platform (SaaS).",
  "roadmap.p3.a1": "Condense our AI workflows into a proprietary platform",
  "roadmap.p3.a2": "Clients can track project progress in real-time via AI Agent interface",
  "roadmap.p3.a3": "Become true AI visual infrastructure",

  // Contact
  "contact.sectionTag": "CONTACT_FORM.init",
  "contact.titleLine1": "Bring your script,",
  "contact.titleMain": "Wake the Monster",
  "contact.desc1": "Whether it\'s a product ad, music MV, digital human IP, or exhibition screen — as long as you have an idea, the monster can turn it into reality with AI compute.",
  "contact.highlight1": "7-day delivery",
  "contact.highlight2": "cinematic quality,",
  "contact.highlight3": "no BS.",
  "contact.emailLabel": "EMAIL",
  "contact.wechatLabel": "WECHAT",
  "contact.followUs": "FOLLOW_US://",
  "contact.nameLabel": "Name *",
  "contact.emailFieldLabel": "Email *",
  "contact.companyLabel": "Company / Brand",
  "contact.projectTypeLabel": "Project Type *",
  "contact.namePlaceholder": "Your name",
  "contact.emailPlaceholder": "your@email.com",
  "contact.companyPlaceholder": "Your company name",
  "contact.projectTypePlaceholder": "Select project type",
  "contact.type1": "Product TVC",
  "contact.type2": "Music MV & Virtual Idols",
  "contact.type3": "Digital Human IP Video",
  "contact.type4": "Exhibition Screen & Offline Visuals",
  "contact.type5": "Other",
  "contact.messageLabel": "Project Description *",
  "contact.messagePlaceholder": "Tell us your ideas and requirements...",
  "contact.submitBtn": "👾 Launch Transmission",
  "contact.submitting": "Transmitting...",
  "contact.success": "Sent Successfully!",

  // Footer
  "footer.brandName": "像素怪兽",
  "footer.tagline1": "AI  Video  Production  Studio",
  "footer.tagline2": "// Wild Ideas · Raw Power · 7-Day Delivery",
  "footer.servicesTitle": "SERVICES",
  "footer.navTitle": "NAV",
  "footer.contactTitle": "CONTACT",
  "footer.s1": "Product TVC",
  "footer.s2": "Music MV Production",
  "footer.s3": "Virtual Idol Incubation",
  "footer.s4": "Digital Human IP",
  "footer.s5": "Exhibition Visuals",
  "footer.s6": "AI Short Drama",
  "footer.nav.about": "About Us",
  "footer.nav.cases": "Portfolio",
  "footer.nav.roadmap": "Roadmap",
  "footer.nav.contact": "Contact Us",
  "footer.locationLabel": "Location",
  "footer.locationValue": "Beijing",
  "footer.deliveryLabel": "Delivery",
  "footer.deliveryValue": "7-Day Express Delivery",
  "footer.copyright": "© 2026 PIXEL MONSTER · All Rights Reserved",
  "footer.motto": "// Don\'t blink — the monster is rendering your imagination",
  "footer.powered": "Powered by AI",

  // Shared service page nav
  "service.backHome": "Back to Home",

  // Digital Human Page
  "dh.badge": "SERVICE_03 / DIGITAL_HUMAN_IP.sys",
  "dh.h1.line1": "Digital Human",
  "dh.h1.line2": "IP Videos",
  "dh.tagline": "// The ultimate spokesperson that never tires",
  "dh.intro": "Real KOLs get tired and raise their prices — our digital humans don\'t. We provide complete AI digital human solutions to make them your exclusive cyber celebrity, producing content for your brand 24/7.",
  "dh.stat1.num": "24/7",
  "dh.stat1.label": "Always On Duty",
  "dh.stat2.num": "$0",
  "dh.stat2.label": "Digital Human Salary",
  "dh.stat3.num": "10x",
  "dh.stat3.label": "Content Output Boost",
  "dh.stat4.num": "∞",
  "dh.stat4.label": "Image Shelf Life",
  "dh.gallery.tag": "// DIGITAL_SHOWCASE",
  "dh.gallery.title": "Digital Human Star Cases",
  "dh.gallery.img1": "Digital Spokesperson · Brand Exclusive Image",
  "dh.gallery.img2": "Short Video Matrix · AI Digital Human Sales",
  "dh.gallery.img3": "Live Stream · Digital Human 24h Sales",
  "dh.gallery.img4": "Brand Mascot · IP Image Incubation",
  "dh.gallery.img5": "Virtual Model · Fashion Brand Endorsement",
  "dh.gallery.img6": "Brand Story · Digital Human Broadcast",
  "dh.features.tag": "// CORE_CAPABILITY",
  "dh.features.title1": "The Era of Real KOLs",
  "dh.features.title2": "Is About to End",
  "dh.feature1.title": "Exclusive Digital Human Incubation",
  "dh.feature1.desc": "Full persona + image customization, from short video matrices to commercial sales videos — end to end",
  "dh.feature2.title": "24/7 Live Stream Sales",
  "dh.feature2.desc": "Digital human guards your livestream room — no breaks, no sick days, always in peak condition",
  "dh.feature3.title": "Zero Scandal Risk",
  "dh.feature3.desc": "Say goodbye to PR crises — digital human endorsements are always the safest bet for your brand",
  "dh.feature4.title": "Content Factory Mode",
  "dh.feature4.desc": "Same image, batch-produce differentiated content — content capacity boosted over 10x",
  "dh.imgTag": "// DIGITAL_HUMAN_ONLINE",
  "dh.process.tag": "// IP_BUILD_WORKFLOW",
  "dh.process.title": "4 Steps to Build Your Cyber Star",
  "dh.step1.title": "IP Planning",
  "dh.step1.desc": "Deep dive into brand tone, design digital human image, persona and core values",
  "dh.step2.title": "Image Modeling",
  "dh.step2.desc": "AI generates ultra-realistic digital human appearance, can match real person or all-new original image",
  "dh.step3.title": "Content Mass Production",
  "dh.step3.desc": "Short video scripts → filming & rendering → post-editing, empowering the brand",
  "dh.step4.title": "Matrix Operations",
  "dh.step4.desc": "Simultaneous publishing across TikTok / Bilibili / Xiaohongshu / WeChat and all platforms",
  "dh.cta.tag": "// YOUR_CYBER_STAR_AWAITS",
  "dh.cta.title1": "Your Exclusive Digital Human",
  "dh.cta.title2": "Never Goes Offline",
  "dh.cta.desc": "One investment, permanent output — the ultimate solution for brand content",
  "dh.cta.btn": "Wake the Monster Now",

  // TVC Page
  "tvc.badge": "SERVICE_01 / PRODUCT_TVC.sys",
  "tvc.h1.line1": "Product Ad",
  "tvc.h1.line2": "Cinematic TVC",
  "tvc.tagline": "// Make your product go absolutely wild on screen",
  "tvc.intro": "Can\'t capture the perfect arc of a water droplet with traditional filming? Can\'t build a futuristic cyberpunk kitchen on set? Hand it to us. We use AI compute to break physical limits and create breathtaking product visual films.",
  "tvc.stat1.num": "200+",
  "tvc.stat1.label": "Brand Cases Served",
  "tvc.stat2.num": "48h",
  "tvc.stat2.label": "Fastest Delivery",
  "tvc.stat3.num": "4K/8K",
  "tvc.stat3.label": "Max Output Resolution",
  "tvc.stat4.num": "∞",
  "tvc.stat4.label": "Creativity Unlimited",
  "tvc.gallery.tag": "// CASE_GALLERY",
  "tvc.gallery.title": "Monster-Level Work Showcase",
  "tvc.gallery.img1": "Smart Home · Futuristic Atmosphere Ad",
  "tvc.gallery.img2": "Men\'s Razor · Epic Special Effects Film",
  "tvc.gallery.img3": "FMCG Beverage · Exploding Liquid Creative Ad",
  "tvc.gallery.img4": "EV Car · Cyber Light Film",
  "tvc.gallery.img5": "Luxury Watch · Minimalist Premium Feel",
  "tvc.gallery.img6": "Gourmet Food · Sensory-Level Food Aesthetics",
  "tvc.features.tag": "// CORE_ADVANTAGE",
  "tvc.features.title1": "Why Choose",
  "tvc.features.title2": "Monster TVC",
  "tvc.feature1.title": "Zero Physical Limits",
  "tvc.feature1.desc": "Water droplet arcs, zero-gravity levitation, extreme close-ups — AI rendering makes the impossible everyday",
  "tvc.feature2.title": "Seamless Style Switching",
  "tvc.feature2.desc": "Cozy family warmth → minimalist luxury → cyberpunk — multiple styles in one project",
  "tvc.feature3.title": "Golden Hour On Demand",
  "tvc.feature3.desc": "No need to wait for perfect weather — in our servers, every day is golden hour",
  "tvc.feature4.title": "7-Day Express Delivery",
  "tvc.feature4.desc": "From creative brief to final cut — completely overturning the months-long traditional production cycle",
  "tvc.imgTag": "// PIXEL_MONSTER_STUDIO_ONLINE",
  "tvc.process.tag": "// WORKFLOW",
  "tvc.process.title": "4 Steps to Complete Your TVC Blockbuster",
  "tvc.step1.title": "Creative Brief",
  "tvc.step1.desc": "Brand submits product info and core needs, we output a creative concept proposal",
  "tvc.step2.title": "AI Storyboard Gen",
  "tvc.step2.desc": "Based on the concept, Monster AI engine generates high-quality storyboards in real-time",
  "tvc.step3.title": "Video Rendering",
  "tvc.step3.desc": "Full compute power on, frame-by-frame rendering, lighting / materials / effects all done",
  "tvc.step4.title": "Deliver & Publish",
  "tvc.step4.desc": "Multi-format output, adapted for TikTok / Bilibili / Cinema / Large Screens",
  "tvc.cta.tag": "// READY_TO_START?",
  "tvc.cta.title1": "Let Your Product",
  "tvc.cta.title2": "Go Absolutely Wild",
  "tvc.cta.desc": "Tell us your product story, the monster will handle everything else",
  "tvc.cta.btn": "Wake the Monster Now",

  // MV Page
  "mv.badge": "SERVICE_02 / MUSIC_MV_VTUBER.sys",
  "mv.h1.line1": "Music MV &",
  "mv.h1.line2": "Virtual Idols",
  "mv.tagline": "// Starmaking? We mass-produce it",
  "mv.intro": "Want to create a super catchy anthem for your brand? Or launch a boy/girl group that never gets cancelled? From AI lyrics and music to MV visuals, from idol persona to full-platform operations — Monster handles it all.",
  "mv.stat1.num": "50+",
  "mv.stat1.label": "Virtual Idols Launched",
  "mv.stat2.num": "Multi-Lang",
  "mv.stat2.label": "AI Vocal Support",
  "mv.stat3.num": "All-In",
  "mv.stat3.label": "One-Stop Service",
  "mv.stat4.num": "0",
  "mv.stat4.label": "Scandal Risk",
  "mv.gallery.tag": "// VISUAL_GALLERY",
  "mv.gallery.title": "Star Factory Portfolio",
  "mv.gallery.img1": "Virtual Idol · Holographic Concert Stage",
  "mv.gallery.img2": "AI MV · Fluid Particle Visuals",
  "mv.gallery.img3": "Digital Idol Group · Cyberpunk Style",
  "mv.gallery.img4": "AI Music Generation · Sound Wave Visualization",
  "mv.gallery.img5": "Virtual Idol · Character Setting Film",
  "mv.gallery.img6": "Brand Theme Song · Live Visual Performance",
  "mv.features.tag": "// WHY_CHOOSE_US",
  "mv.features.title1": "The Never-Cancelled",
  "mv.features.title2": "Super Star Factory",
  "mv.feature1.title": "Full Songwriting · Multi-Language Vocals",
  "mv.feature1.desc": "AI vocals in Chinese, Japanese, Korean, English — one song conquers the global market",
  "mv.feature2.title": "Exclusive Persona Design",
  "mv.feature2.desc": "From looks and voice to personality — build the digital star that belongs only to your brand",
  "mv.feature3.title": "MV Production End-to-End",
  "mv.feature3.desc": "After music generation, seamlessly connect to MV visual production — infinite style possibilities",
  "mv.feature4.title": "Zero Scandal Risk",
  "mv.feature4.desc": "Digital idols never have affairs, never get tired — the safest brand ambassador you can have",
  "mv.imgTag": "// IDOL_SYSTEM_ONLINE",
  "mv.process.tag": "// STAR_FACTORY_WORKFLOW",
  "mv.process.title": "4 Steps to Debut Your Virtual Idol",
  "mv.step1.title": "Persona Design",
  "mv.step1.desc": "Brand defines idol style, vocal direction, and visual image parameters",
  "mv.step2.title": "AI Songwriting",
  "mv.step2.desc": "Generate multilingual exclusive songs based on brand tone — lyrics, music, and vocals included",
  "mv.step3.title": "MV Visual Generation",
  "mv.step3.desc": "Idol image and MV footage blend-rendered — every frame is cinematic quality",
  "mv.step4.title": "Full-Platform Release",
  "mv.step4.desc": "Multi-format one-click adaptation for TikTok / Bilibili / YouTube / Instagram",
  "mv.cta.tag": "// YOUR_IDOL_IS_WAITING",
  "mv.cta.title1": "Your Exclusive Star",
  "mv.cta.title2": "Standing By",
  "mv.cta.desc": "Starting from one idea, Monster helps you build the entire star-making universe",
  "mv.cta.btn": "Wake the Monster Now",

  // Exhibition Page
  "ex.badge": "SERVICE_04 / EXHIBITION_SCREEN.sys",
  "ex.h1.line1": "Exhibition Screens &",
  "ex.h1.line2": "Offline Visuals",
  "ex.tagline": "// The ultimate retina-shattering weapon",
  "ex.intro": "Industry expos, AI art festivals, tech conferences — make potential clients lock eyes with your brand at first glance. Massive scale, ultra-high resolution — every pixel the monster renders helps you capture offline traffic.",
  "ex.stat1.num": "8K+",
  "ex.stat1.label": "Max Output Resolution",
  "ex.stat2.num": "Naked-Eye 3D",
  "ex.stat2.label": "Immersive Visual Tech",
  "ex.stat3.num": "All-Venue",
  "ex.stat3.label": "Offline Visual Coverage",
  "ex.stat4.num": "100%",
  "ex.stat4.label": "Eyeball Capture Rate",
  "ex.gallery.tag": "// VISUAL_IMPACT_GALLERY",
  "ex.gallery.title": "Stunning Visual Portfolio",
  "ex.gallery.img1": "Industry Expo · LED Mega Screen Impact",
  "ex.gallery.img2": "Naked-Eye 3D · City-Scale Visual Installation",
  "ex.gallery.img3": "Tech Conference · Main Stage Visual Backdrop",
  "ex.gallery.img4": "AI Art Festival · Immersive Experience Space",
  "ex.gallery.img5": "City Sandbox · Grand Future City Showcase",
  "ex.gallery.img6": "Outdoor Screen · Ultra-HD Billboard",
  "ex.features.tag": "// SCREEN_ADVANTAGE",
  "ex.features.title1": "Make Your Booth",
  "ex.features.title2": "The Center of Attention",
  "ex.feature1.title": "Massive Ultra-HD Output",
  "ex.feature1.desc": "8K and above resolution output — ultra-widescreen / shaped screen / multi-screen splicing all supported",
  "ex.feature2.title": "Naked-Eye 3D Pioneering Visuals",
  "ex.feature2.desc": "Immersion without glasses — make your product literally \"walk out\" of the screen",
  "ex.feature3.title": "City-Scale Sandbox Visuals",
  "ex.feature3.desc": "Grand future city planning showcase — the ultimate tech-vibes expo weapon",
  "ex.feature4.title": "All-Venue Offline Coverage",
  "ex.feature4.desc": "Expos / stores / events / outdoor billboards — one creative concept, multi-venue reuse",
  "ex.imgTag": "// SCREEN_RESOLUTION_8K+",
  "ex.process.tag": "// DELIVERY_WORKFLOW",
  "ex.process.title": "4 Steps to Build Your Offline Visual Battleground",
  "ex.step1.title": "Needs Diagnosis",
  "ex.step1.desc": "Confirm expo / venue specs, align output device params, plan visual strategy",
  "ex.step2.title": "Creative Generation",
  "ex.step2.desc": "Generate visual concepts based on brand tone, with dedicated large-screen resolution adaptation",
  "ex.step3.title": "High-Res Rendering",
  "ex.step3.desc": "Monster compute at full power — 8K / ultra-wide / shaped screen full-spec rendering",
  "ex.step4.title": "On-Site Setup & Delivery",
  "ex.step4.desc": "On-site device hookup and calibration supported — every frame delivered perfectly",
  "ex.cta.tag": "// DOMINATE_THE_FLOOR",
  "ex.cta.title1": "At the Next Expo",
  "ex.cta.title2": "Everyone\'s Watching You",
  "ex.cta.desc": "The offline traffic battle — Monster helps you crush all competition with pixels",
  "ex.cta.btn": "Wake the Monster Now",
};

export default en;
